import { modals } from './modals'
import { helpers } from './helpers'


export const afterSales = {
    nextProdNum: 2,
    init: () => {
        console.debug('afterSales.js: init');
        afterSales.formListener()
        afterSales.formReturnProducts()
        afterSales.addImageRemoveButtons();
    },
    formListener: () => {
        document.querySelector(".fresh-form").addEventListener("submit", (e) => {
            e.preventDefault()
            const formData = new FormData(e.target)
            const lang = formData.get("language")
            const fetchOptions = {
                method: 'POST',
                body: formData,
            }
            const reqTicket = new Request("/misc/ticket.php", fetchOptions)

            afterSales.displayWaitMsg(lang)
            try {
                fetch(reqTicket)
                    .then(res => {
                        switch (res.status) {
                            case 201:
                                return res.json()
                            case 400:
                                return res.json()
                            case 413:
                                return new Promise((resolve, _) => {
                                    resolve({ error: "file too large" })
                                })
                            case 500:
                                helpers.alertEmail({
                                    sender: "afterSales_Form",
                                    subject: "server error",
                                    ctx: "ticket endpoint",
                                    msg: "internal server error when creating ticket",
                                    status: res.status,
                                    customer: {
                                        name: formData.get("custName"),
                                        email: formData.get("custEmail"),
                                        orderNr: formData.get("orderNumber"),
                                    }
                                })
                                return new Promise((resolve, _) => {
                                    resolve({ status: "FAILED" })
                                })
                            default:
                                helpers.alertEmail({
                                    sender: "afterSales_Form",
                                    subject: "unhandled status",
                                    ctx: "ticket endpoint",
                                    msg: "status not handled",
                                    status: res.status,
                                    customer: {
                                        name: formData.get("custName"),
                                        email: formData.get("custEmail"),
                                        orderNr: formData.get("orderNumber"),
                                    }
                                })
                                return new Promise((resolve, _) => {
                                    resolve({ error: "Something went wrong while creating the ticket. Please contact our support. (code: " + res.status + ")" })
                                })
                        }
                    })
                    .then(json => {
                        if ("OK" === json.status) {
                            afterSales.switchOkMsg(lang)
                            afterSales.resetForm()
                            setTimeout(() => {
                                window.location.href = prestashop.urls.base_url + "content/120-"
                            }, 20000);

                        } else if (json.error) {
                            afterSales.switchFailMsg(lang, json.error)
                        } else {
                            afterSales.switchFailMsg(lang, "Something went wrong while creating the ticket. Please contact our support.")
                            helpers.alertEmail({
                                sender: "afterSales_Form",
                                subject: "unhandled json",
                                ctx: "ticket endpoint",
                                msg: "unhandled json response",
                                json: json,
                                customer: {
                                    name: formData.get("custName"),
                                    email: formData.get("custEmail"),
                                    orderNr: formData.get("orderNumber"),
                                }
                            })
                        }
                    })
                    .catch(error => {
                        afterSales.switchFailMsg(lang, "failed to create ticket")
                        helpers.alertEmail({
                            sender: "afterSales_Form",
                            subject: "unhandled error",
                            ctx: "ticket endpoint",
                            msg: "error not handled",
                            err: error.message
                        })
                    })
            } catch (error) {
                afterSales.switchFailMsg(lang, "something went wrong")
                helpers.alertEmail({
                    sender: "afterSales_Form",
                    subject: "try/catch formListener.",
                    ctx: "afterSales formListener",
                    msg: "unhandled error in formListener. Caught by final try/catch in formListener.",
                    err: error.message
                })
            }
        })
    },
    resetForm: () => {
        document.querySelectorAll(".fresh-form__input").forEach(input => {
            if (input.type !== "submit" && input.type !== "hidden" && input.type !== `checkbox`) {
                input.value = ""
            } else if (input.type === "checkbox") {
                input.checked = false
            }
        })
        afterSales.nextProdNum = 2
        document.querySelectorAll("#fresh-form__products > .fresh-form__subsection--addable")
            .forEach((section, key) => {
                if (key >= 1) { section.remove() }
            })
        modals.ol.off();
        modals.ol.click(() => {
            window.location.href = prestashop.urls.base_url + "content/120-"
        });
    },
    formReturnProducts: () => {
        // CLONES THE PRODUCT SECTION
        const cloneProductSection = (node, num) => {
            const newNode = node.cloneNode(true)
            newNode.querySelector('span.fresh-form__prod-num').innerHTML = num
            newNode.querySelectorAll(".fresh-form__input").forEach(input => {
                if (input.type !== "submit" && input.type !== "hidden" && input.type !== `checkbox`) {
                    input.value = ""
                } else if (input.type === "checkbox") {
                    input.checked = false
                }
                // replace the id with the new one
                input.id = input.id.replace(/\d+/, num)
                input.name = input.name.replace(/\d+/, num)
            })
            return newNode
        }
        // RETURNS EXTRA PRODUCTS
        const afterSalesReturnMaxProducts = 5
        if (document.querySelector('#right-of-withdrawal-wrapper')) {
            const addButton = document.querySelector('#fresh-form__action--add-product')
            const wrapper = document.querySelector('#fresh-form__products')
            addButton.addEventListener('click', () => {
                const cloneable = document.querySelector('.fresh-form__subsection--addable')
                wrapper.appendChild(cloneProductSection(cloneable, afterSales.nextProdNum))
                if (afterSales.nextProdNum >= afterSalesReturnMaxProducts) {
                    addButton.style.display = 'none'
                } else {
                    afterSales.nextProdNum++
                }

            })
        }
    },
    displayWaitMsg: (lang) => {
        lang = lang.toUpperCase();

        if (lang === "SE" || lang === "SV") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <div class="after-sales-modal__spinner"></div>
                <p>Vi bearbetar ditt ärende</p>
                </div>
                `)
                $("#after-sales-modal").show()
                modals.togglePageOverlay()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "DE") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <div class="after-sales-modal__spinner"></div>
                <p>Bei der Bearbeitung Ihres Falles</p>
                </div>
                `)
                $("#after-sales-modal").show()
                modals.togglePageOverlay()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "FI") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <div class="after-sales-modal__spinner"></div>
                <p>Käsittelemme tapaustasi</p>
                </div>
                `)
                $("#after-sales-modal").show()
                modals.togglePageOverlay()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "NL") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <div class="after-sales-modal__spinner"></div>
                <p>We zijn uw zaak aan het verwerken</p>
                </div>
                `)
                $("#after-sales-modal").show()
                modals.togglePageOverlay()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "FR") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <div class="after-sales-modal__spinner"></div>
                <p>Nous traitons votre dossier</p>
                </div>
                `)
                $("#after-sales-modal").show()
                modals.togglePageOverlay()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "DK") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <div class="after-sales-modal__spinner"></div>
                <p>Vi behandler din sag</p>
                </div>
                `)
                $("#after-sales-modal").show()
                modals.togglePageOverlay()
            } catch (error) {
                console.log(error)
            }
        } else {
            console.log("unknown language parameter: %s", lang)
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <div class="after-sales-modal__spinner"></div>
                <p>Your ticket is being processed</p>
                </div>
                `)
                $("#after-sales-modal").show()
                modals.togglePageOverlay()
            } catch (error) {
                console.log(error)
            }
        }
    },
    switchOkMsg: (lang) => {
        if (lang === "SE") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <img class="modal-image" src="${prestashop.urls.img_url}icons/heart-filled.svg" alt="hjärta">
                <h2>Tack för din anmälan</h2>
                <p>Vi behandlar ditt ärende och återkommer till dig snarast.</p>
                <p>Du dirigeras nu tillbaka till <a href="/content/120-">Returer och Reklamationer</a></p>
                </div>
                `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "DE") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <img class="modal-image" src="${prestashop.urls.img_url}icons/heart-filled.svg" alt="heart">
                <h2>Vielen Dank für Ihre Anmeldung</h2>
                <p>Wir werden Ihren Fall bearbeiten und uns so schnell wie möglich bei Ihnen melden.</p>
                <p>Sie werden nun zurückgeleitet zu <a href="/de/content/120-">Rücksendungen und Reklamationen</a></p>
                </div>
                `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "FI") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <img class="modal-image" src="${prestashop.urls.img_url}icons/heart-filled.svg" alt="heart">
                <h2>Kiitos rekisteröitymisestäsi</h2>
                <p>Käsittelemme tapauksesi ja otamme sinuun yhteyttä mahdollisimman pian.</p>
                <p>Sinut ohjataan nyt takaisin <a href="/fi/content/120-">Palautuksiin ja valituksiin</a></p>
                </div>
                `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "NL") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <img class="modal-image" src="${prestashop.urls.img_url}icons/heart-filled.svg" alt="heart">
                <h2>Bedankt voor je registratie</h2>
                <p>We zullen uw zaak in behandeling nemen en zo snel mogelijk contact met u opnemen.</p>
                <p>Je wordt nu teruggeleid naar <a href="/nl/content/120-">Retouren en klachten</a></p>
                </div>
                `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "FR") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <img class="modal-image" src="${prestashop.urls.img_url}icons/heart-filled.svg" alt="heart">
                <h2>Merci pour votre inscription</h2>
                <p>Nous traiterons votre dossier et vous répondrons dans les plus brefs délais.</p>
                <p>Vous êtes maintenant redirigé vers <a href="/fr/content/120-">Retours et réclamations</a></p>
                </div>
                `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "DK") {
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <img class="modal-image" src="${prestashop.urls.img_url}icons/heart-filled.svg" alt="heart">
                <h2>Tak for din tilmelding</h2>
                <p>Vi behandler din sag og vender tilbage til dig så hurtigt som muligt.</p>
                <p>Du er nu dirigeret tilbage til <a href="/dk/content/120-">Returneringer og klager</a></p>
                </div>
                `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        } else {
            console.log("unknown language parameter: %s", lang)
            try {
                modals.ol.html(`
                <div class="modal-box" id="after-sales-modal">
                <img class="modal-image" src="${prestashop.urls.img_url}icons/heart-filled.svg" alt="heart">
                <h2>Thank you for reaching out!</h2>
                <p>You are being redirected back to <a href="/content/120-">the After Sales page</a></p>
                </div>
                `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        }
    },
    switchFailMsg: (lang, msg) => {
        if (lang === "SE") {
            try {
                modals.ol.html(`
            <div class="modal-box error" id="after-sales-modal">
            <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="stäng">
            </div>
            <img class="modal-image" src="${prestashop.urls.img_url}icons/info.svg" alt="info">
            <h2>Något gick fel</h2>
            <p>Felmeddelande: ${msg}</p>
            <p><a class="button-link" href="/kontakta-oss">Kontakta oss här istället.</a></p>
            </div>
            `)
                $("#after-sales-modal").show()

            } catch (error) {
                console.log(error)
            }
        } else if (lang === "DE") {
            try {
                modals.ol.html(`
            <div class="modal-box error" id="after-sales-modal">
            <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="schließen">
            </div>
            <img class="modal-image" src="${prestashop.urls.img_url}icons/info.svg" alt="info">
            <h2>Etwas ist schief gelaufen</h2>
            <p>Fehlermeldung: ${msg}</p>
            <p><a class="button-link" href="/de/kontakt">Kontaktieren Sie uns stattdessen hier.</a></p>
            </div>
            `)
                $("#after-sales-modal").show()
            } catch (error) {
                console.log(error)
            }
        } else if (lang === "FI") {
            try {
                modals.ol.html(`
            <div class="modal-box error" id="after-sales-modal">
            <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="sulkea">
            </div>
            <img class="modal-image" src="${prestashop.urls.img_url}icons/info.svg" alt="info">
            <h2>Jotain meni pieleen</h2>
            <p>Virheviesti: ${msg}</p>
            <p><a class="button-link" href="/fi/ota-yhteytta">Ota sen sijaan meihin yhteyttä tästä.</a></p>
            </div>
            `)
                $("#after-sales-modal").show()

            } catch (error) {
                console.log(error)
            }
        } else if (lang === "NL") {
            try {
                modals.ol.html(`
            <div class="modal-box error" id="after-sales-modal">
            <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="afsluiten">
            </div>
            <img class="modal-image" src="${prestashop.urls.img_url}icons/info.svg" alt="info">
            <h2>Er is iets fout gegaan</h2>
            <p>Foutmelding: ${msg}</p>
            <p><a class="button-link" href="/nl/ota-yhteytta">Neem in plaats daarvan hier contact met ons op.</a></p>
            </div>
            `)
                $("#after-sales-modal").show()

            } catch (error) {
                console.log(error)
            }
        } else if (lang === "FR") {
            try {
                modals.ol.html(`
            <div class="modal-box error" id="after-sales-modal">
            <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="terminer">
            </div>
            <img class="modal-image" src="${prestashop.urls.img_url}icons/info.svg" alt="info">
            <h2>Quelque chose s'est mal passé</h2>
            <p>Message d'erreur: ${msg}</p>
            <p><a class="button-link" href="/fr/nous-contacter">Contactez-nous plutôt ici.</a></p>
            </div>
            `)
                $("#after-sales-modal").show()

            } catch (error) {
                console.log(error)
            }
        } else if (lang === "DK") {
            try {
                modals.ol.html(`
            <div class="modal-box error" id="after-sales-modal">
            <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="luk">
            </div>
            <img class="modal-image" src="${prestashop.urls.img_url}icons/info.svg" alt="info">
            <h2>Noget gik galt</h2>
            <p>Fejl besked: ${msg}</p>
            <p><a class="button-link" href="/dk/kontakt-os">Kontakt os i stedet her.</a></p>
            </div>
            `)
                $("#after-sales-modal").show()

            } catch (error) {
                console.log(error)
            }
        } else {
            console.log("unknown language parameter: %s", lang)
            try {
                modals.ol.html(`
            <div class="modal-box error" id="after-sales-modal">
            <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="close">
            </div>
            <img class="modal-image" src="${prestashop.urls.img_url}icons/info.svg" alt="info">
            <h2>Something went wrong</h2>
            <p>${msg}</p>
            </div>
            `)
                $("#after-sales-modal").show()

            } catch (error) {
                console.log(error)
            }
        }
    },
    switchTicket: (debugString, ticket) => {
        try {
            modals.ol.html(`
            <div class="modal-box" id="after-sales-modal">
                <div class="close-modal">
                    <img src="${prestashop.urls.img_url}icons/cross.svg" alt="stäng">
                </div>

                <div style="text-align: left;">
                    <p style="color:red;"><strong>${debugString}</strong></p>
                    <h2>Ticket Preview:</h2>
                    <p>${ticket}</p>
                </div>
            </div>
            `)
            $("#after-sales-modal").show()
        } catch (error) {
            console.log(error)
        }
    },
    addImageRemoveButtons: () => {
        try {
            let freshFormFileInputs = ".fresh-form input[type=file]";
            // Add onchange event for upload input
            $(freshFormFileInputs).change(function () {
                afterSales.addImageRemoveButtonsRun();
            });
            // Init the script
            afterSales.addImageRemoveButtonsRun();
        } catch (error) {
            console.log(error)
        }
    },
    addImageRemoveButtonsRun: () => {
        try {
            // Add remove image-icons and change the styling
            let freshFormFileInputs = ".fresh-form input[type=file]";
            $(".remove-image-btn-span").remove();
            $(freshFormFileInputs).each(function () {
                $(this).css("background-color", "#eeeeee");
                $(this).css("padding", "5px");
                if ($(this).val() != "") {
                    $(this).after('<span class="remove-image-btn-span" name="' + $(this).attr("name") + '" style="position: relative; left: -25px; top: -1px;cursor:pointer;"><svg class="svg-inline--fa fa-times-circle fa-w-16 close-modal remove-image-btn" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg></span>');
                } else {
                    $(this).after('<span class="remove-image-btn-span" style="position: relative; left: -25px; top: -1px;cursor:pointer;"><svg class="svg-inline--fa fa-times-circle fa-w-16 close-modal remove-image-btn" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""></svg></span>');
                }
            });
            // Remove image when clicking the span added in the code above
            $(".remove-image-btn-span").click(function () {
                afterSales.removeAddedImage($(this).attr("name"));
            });
        } catch (error) {
            console.log(error)
        }
    },
    removeAddedImage: (name) => {
        try {
            // Remove image and update view
            $(".fresh-form input[name='" + name + "']").val("");
            afterSales.addImageRemoveButtonsRun();
        } catch (error) {
            console.log(error)
        }
    }
}



